import {
  REQUEST_GET_TIMERANGE_INTELLEGENCE,
  RESPONSE_GET_TIMERANGE_INTELLEGENCE,
  REQUEST_GET_TIMERANGE_INTELLEGENCE_FAILURE,
  CLEAR_INTELLIGENCE
} from '../actions/timerangeIntelligenceActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  carId: null,
  startDate: new Date(),
  endDate: new Date(),
}

const timerangeIntellegenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_TIMERANGE_INTELLEGENCE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST
        },
        action.data
      )
    case RESPONSE_GET_TIMERANGE_INTELLEGENCE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
        }
      )
    case REQUEST_GET_TIMERANGE_INTELLEGENCE_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: states.FAILURE
        }
      )
    case CLEAR_INTELLIGENCE:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default timerangeIntellegenceReducer